const galleryId = 75;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_767551351.jpg","sh_1256946910.jpg","sh_1443382517.jpg","sh_1562633719.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Temporary bridge'));

group = ["sh_1820627351.jpg","sh_1820627357.jpg"];
group.forEach((i) => addItemToGroup(i, 'x_new'));

export default items;
